import { createApi } from '@reduxjs/toolkit/query/react'
import { store } from 'app/store'
import { API_ENDPOINTS } from 'Constants'
import { pospUrlQuery } from 'Services/baseQuery'
import { ToastService } from 'Services/toast.service'

export const pospApi: any = createApi({
  reducerPath: 'pospApi',
  baseQuery: pospUrlQuery,
  keepUnusedDataFor: 0.1,
  endpoints: (builder) => ({
    personalDetailsUpload: builder.mutation<any, any>({
      query: (personalDetailsPayload: any) => ({
        url: API_ENDPOINTS.PERSONAL_DETAILS,
        method: 'POST',
        body: personalDetailsPayload,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
          // ToastService.showSuccessTaost({
          //   title: 'Details Saved Successfully.',
          //   message: 'Check dashboard.',
          // });
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    updatePan: builder.mutation<any, any>({
      query: (updatePanPayload: { pan_number: any }) => ({
        url: API_ENDPOINTS.UPDATE_PAN,
        method: 'POST',
        body: updatePanPayload,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
          // ToastService.showSuccessTaost({
          //   title: 'Details Saved Successfully.',
          //   message: 'Check dashboard.',
          // });
        } catch (e: any) {
          console.log('Error', e)
          // ToastService.showErrorToast({
          //   title: 'Error',
          //   message: e.error.data.message,
          // })
        }
      },
    }),
    userStateUpdate: builder.mutation<any, any>({
      query: (userStatePayload: any) => ({
        url: API_ENDPOINTS.UPDATE_USER_STATE,
        method: 'POST',
        body: userStatePayload,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const resp = await queryFulfilled
          console.log('Data Captured', resp)
          // ToastService.showSuccessTaost({
          //   title: 'Details Saved Successfully.',
          //   message: 'Check dashboard.',
          // });
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    getUserState: builder.query<any, any>({
      query: (formsParams: { user_id: number }) => ({
        url: API_ENDPOINTS.GET_USER_STATE,
        method: 'GET',
        params: formsParams,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('Get user state data: ', data)
        } catch (e: any) {
          console.log(e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    getExamQuestions: builder.query<any, any>({
      query: ({ question_type }: { question_type: string }) => ({
        url: API_ENDPOINTS.GET_EXAM_QUESTIONS,
        method: 'GET',
        params: { question_type },
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('Get exam question data: ', data)
        } catch (e: any) {
          console.log(e, 'error')
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),

    examAnswerUpload: builder.mutation<any, any>({
      query: (answerPayload: any) => ({
        url: API_ENDPOINTS.SUBMIT_EXAM_ANSWERS,
        method: 'POST',
        body: answerPayload,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
          // ToastService.showSuccessTaost({
          //   title: 'Details Saved Successfully.',
          //   message: 'Check dashboard.',
          // });
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),

    getUserRemarks: builder.query<any, any>({
      query: (formsParams: { user_id: number; qc_level: number }) => ({
        url: API_ENDPOINTS.GET_USER_REMARKS,
        method: 'GET',
        params: formsParams,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('User Remarks: ', data)
        } catch (e: any) {
          console.log(e, 'error')
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    registerUser: builder.mutation<any, any>({
      query: (detailsPayload: any) => ({
        url: API_ENDPOINTS.REGISTER_USER,
        method: 'POST',
        body: detailsPayload,
        headers: {},
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const data = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          // ToastService.showErrorToast({
          //   title: 'Error',
          //   message: e.error.data.message,
          // })
        }
      },
    }),
    fileUpload: builder.mutation<any, any>({
      query: (fileData: any) => ({
        url: API_ENDPOINTS.UPLOAD_USER_DOCUMENTS,
        method: 'POST',
        body: fileData,
        headers: {
          authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
          'Content-Type': 'multipart/form-data',
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
          // ToastService.showSuccessTaost({
          //   title: 'Details Saved Successfully.',
          //   message: 'Check dashboard.',
          // });
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    getUploadedDocuments: builder.query<any, any>({
      query: () => ({
        url: API_ENDPOINTS.UPLOAD_USER_DOCUMENTS,
        method: 'GET',
        headers: {
          authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
          // ToastService.showSuccessTaost({
          //   title: 'Details Saved Successfully.',
          //   message: 'Check dashboard.',
          // });
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    updatePersonalDetails: builder.mutation<any, any>({
      query: (personalDetailsPayload: any) => ({
        url: API_ENDPOINTS.UPDATE_PERSONAL_DETAILS,
        method: 'POST',
        body: personalDetailsPayload,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const data = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          // ToastService.showErrorToast({
          //   title: 'Error',
          //   message: e.error.data.message,
          // })
        }
      },
    }),
    loginUser: builder.mutation<any, any>({
      query: (phoneNumPayload: any) => ({
        url: API_ENDPOINTS.LOGIN_USER,
        method: 'POST',
        body: phoneNumPayload,
        headers: {},
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const data = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    verifyOTP: builder.mutation<any, any>({
      query: (verifyOtpPayload: { phone_no: string; otp: string }) => ({
        url: API_ENDPOINTS.VERIFY_OTP,
        method: 'POST',
        body: verifyOtpPayload,
        headers: {},
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    getDetails: builder.query<any, any>({
      query: (token) => ({
        url: API_ENDPOINTS.GET_DETAILS,
        method: 'GET',
        headers: {
          authorization: `Token ${token}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    getTrainingData: builder.query<any, any>({
      query: (trainingType: string) => ({
        url: `${API_ENDPOINTS.GET_TRAINING_DATA}${trainingType}/`,
        method: 'GET',
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('User Remarks: ', data)
        } catch (e: any) {
          console.log(e, 'error')
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    setVideoWatchLogs: builder.mutation<any, any>({
      query: (videoWatchLogsPayload: { current_duration: number; video_id: number }) => ({
        url: API_ENDPOINTS.VIDEO_WATCH_LOGS,
        method: 'POST',
        body: videoWatchLogsPayload,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
        }
      },
    }),
    getJourneyDetails: builder.query<any, any>({
      query: () => ({
        url: API_ENDPOINTS.GET_JOURNEY_DETAILS,
        method: 'GET',
        headers: {
          authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    updateUserType: builder.mutation<any, any>({
      query: (userTypePayload: { user_type: string }) => ({
        url: API_ENDPOINTS.UPDATE_USER_TYPE,
        method: 'POST',
        body: userTypePayload,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const data = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    getNetworkManager: builder.query<any, any>({
      query: (queryParams: { posp_id: string }) => ({
        url: API_ENDPOINTS.GET_NETWORK_MANAGER,
        method: 'GET',
        params: queryParams,
        headers: {
          authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    uploadNocDocument: builder.mutation<any, any>({
      query: (uploadNocDocPayload: any) => ({
        url: API_ENDPOINTS.UPLOAD_NOC_DOCUMENT,
        method: 'POST',
        body: uploadNocDocPayload,
        headers: {
          Authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const data = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    reuploadDocuments: builder.mutation<any, any>({
      query: (fileData: any) => ({
        url: API_ENDPOINTS.UPLOAD_USER_DOCUMENTS,
        method: 'PATCH',
        body: fileData,
        headers: {
          authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
          'Content-Type': 'multipart/form-data',
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          console.log('Data Captured', data)
          // ToastService.showSuccessTaost({
          //   title: 'Details Saved Successfully.',
          //   message: 'Check dashboard.',
          // })
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),

    logoutUser: builder.mutation<any, any>({
      query: (systemPayload: { idle: boolean }) => ({
        url: API_ENDPOINTS.LOGOUT_USER,
        method: 'POST',
        body: systemPayload,
        headers: {
          authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    getBankNames: builder.query<any, any>({
      query: () => ({
        url: API_ENDPOINTS.GET_BANK_NAME,
        method: 'GET',
        headers: {
          authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),

    sendWatchTimeLogs: builder.mutation<any, any>({
      query: (watchTimePayload: { training_current_sec: string }) => ({
        url: API_ENDPOINTS.SEND_WATCH_TIME_LOGS,
        method: 'POST',
        body: watchTimePayload,
        headers: {
          authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    fetchStampedPDF: builder.mutation<any, any>({
      query: (fetchStampPayload: { uuid: string }) => ({
        url: API_ENDPOINTS.FETCH_STAMPED_PDF,
        method: 'POST',
        body: fetchStampPayload,
        // headers: {
        //   authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        // },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    sendOTPforStampPaper: builder.mutation<any, any>({
      query: (sendOtpPayload: { uuid: string }) => ({
        url: API_ENDPOINTS.SEND_OTP_FOR_STAMP_PAPER,
        method: 'POST',
        body: sendOtpPayload,
        headers: {},
        // headers: {
        //   authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        // },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    verifyOtpForStampPaper: builder.mutation<any, any>({
      query: (verifyOtpPayload: { uuid: string; otp: string }) => ({
        url: API_ENDPOINTS.VERIFY_OTP_FOR_STAMP_PAPER,
        method: 'POST',
        body: verifyOtpPayload,
        // headers: {
        //   authorization: `Token ${store.getState().user.authenticatedUser.authtoken}`,
        // },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // console.log('Data Captured', data)
        } catch (e: any) {
          console.log('Error', e)
          ToastService.showErrorToast({
            title: 'Error',
            message: e.error.data.message,
          })
        }
      },
    }),
    getStampPaperStatus: builder.query<any, any>({
      query: ({ uuid }: { uuid: string }) => ({
        url: API_ENDPOINTS.FETCH_STAMPED_PDF,
        method: 'GET',
        params: { uuid },
        headers: {},
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (e: any) {
          console.log('Error', e)
        }
      },
    }),
  }),
})

export const {
  useGetExamQuestionsQuery,
  useUpdatePanMutation,
  useGetUserStateQuery,
  usePersonalDetailsUploadMutation,
  useUserStateUpdateMutation,
  useExamAnswerUploadMutation,
  useGetUserRemarksQuery,
  useRegisterUserMutation,
  useFileUploadMutation,
  useUpdatePersonalDetailsMutation,
  useLoginUserMutation,
  useVerifyOTPMutation,
  useLazyGetDetailsQuery,
  useGetJourneyDetailsQuery,
  useLazyGetTrainingDataQuery,
  useSetVideoWatchLogsMutation,
  useUpdateUserTypeMutation,
  useLazyGetNetworkManagerQuery,
  useUploadNocDocumentMutation,
  useGetUploadedDocumentsQuery,
  useReuploadDocumentsMutation,
  useLogoutUserMutation,
  useGetBankNamesQuery,
  useSendWatchTimeLogsMutation,
  useFetchStampedPDFMutation,
  useSendOTPforStampPaperMutation,
  useVerifyOtpForStampPaperMutation,
  useGetStampPaperStatusQuery,
} = pospApi
